import * as React from 'react';
import { AdminTabsContainerState, HighlightMarkupTypes } from '.';

const AdminTabsContext = React.createContext<AdminTabsContextValues>({} as any);
export default AdminTabsContext;

export type AdminTabsContextValues = AdminTabsContainerState & {
	setActiveTab: (tab: string) => void;
	setActiveTabContent: (tab: string) => void;
	registerTab: (tab: string) => void;
	setValidationError: (tab: string, id: string, submitError?: any) => void;
	highlightTab: (tab: string, highlightMarkUp?: HighlightMarkupTypes) => void;
};

/**
 * HOC used to simplify accessing context from anything that uses AdminTabsContext.
 * @param WrappedComponent
 */
export const withAdminTabsContext = (WrappedComponent) => {
	const AdminTabsComponent: any = (props) => {
		return (
			<AdminTabsContext.Consumer>
				{(value: AdminTabsContextValues) => <WrappedComponent {...props} adminTabsContext={value} />}
			</AdminTabsContext.Consumer>
		);
	};

	const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	AdminTabsComponent.displayName = `withAdminTabsContext(${wrappedComponentName})`;
	AdminTabsComponent.WrappedComponent = WrappedComponent;

	return AdminTabsComponent;
};
